import { useContext, useEffect, useState } from "react";
import axios from "../api/httpClient";
import { GlobalState } from "../data/Context";
import {
  clearStoredSession,
  getApiBaseUrl,
  getStoredOrganization,
  hasStoredSession,
  setStoredSession,
} from "../data/authStorage";

const useAuthBootstrap = () => {
  const { setOrganization } = useContext(GlobalState);
  const [isBootstrapped, setIsBootstrapped] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const hydrateSession = async () => {
      if (!hasStoredSession()) {
        setOrganization(null);
        if (isMounted) {
          setIsBootstrapped(true);
        }
        return;
      }

      const cachedOrganization = getStoredOrganization();

      if (cachedOrganization) {
        setOrganization(cachedOrganization);
      }

      try {
        const apiBaseUrl = getApiBaseUrl();

        if (!apiBaseUrl) {
          clearStoredSession();
          setOrganization(null);
          if (isMounted) {
            setIsBootstrapped(true);
          }
          return;
        }

        const response = await axios.get(`${apiBaseUrl}/auth/organization/me`, {
          timeout: 8000,
        });
        const organization = response?.data?.organization || null;

        if (!isMounted) {
          return;
        }

        if (organization) {
          setStoredSession({ organization });
          setOrganization(organization);
        }
      } catch (error) {
        // If it's a 401 error, dispatch sessionExpired event
        if (error?.response?.status === 401) {
          window.dispatchEvent(new CustomEvent("sessionExpired"));
        }
        clearStoredSession();
        setOrganization(null);
      } finally {
        if (isMounted) {
          setIsBootstrapped(true);
        }
      }
    };

    hydrateSession();

    return () => {
      isMounted = false;
    };
  }, [setOrganization]);

  return isBootstrapped;
};

export default useAuthBootstrap;